import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../utils/cn';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        pending:
          'border-transparent bg-gray-500 text-white shadow hover:bg-gray-600',
        running:
          'border-transparent bg-blue-500 text-white shadow hover:bg-blue-600',
        success:
          'border-transparent bg-green-500 text-white shadow hover:bg-green-600',
        failed:
          'border-transparent bg-red-500 text-white shadow hover:bg-red-600',
        cancelled:
          'border-transparent bg-orange-500 text-white shadow hover:bg-orange-600',
        warning:
          'border-transparent bg-yellow-500 text-white shadow hover:bg-yellow-600',
        info:
          'border-transparent bg-cyan-500 text-white shadow hover:bg-cyan-600',
        destructive:
          'border-transparent bg-red-500 text-white shadow hover:bg-red-600',
        secondary:
          'border-transparent bg-gray-400 text-white shadow hover:bg-gray-500',
        outline:
          'text-foreground border-border',
      },
    },
    defaultVariants: {
      variant: 'pending',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
